import { render, staticRenderFns } from "./stadistics.vue?vue&type=template&id=a6430b1a"
import script from "./stadistics.vue?vue&type=script&lang=js"
export * from "./stadistics.vue?vue&type=script&lang=js"
import style0 from "./stadistics.vue?vue&type=style&index=0&id=a6430b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports